import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "@/i18n/I18nContext";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer className="relative border-t border-white/10 bg-[#07070d] overflow-hidden" data-testid="site-footer">
      <div className="aura w-[400px] h-[400px] bg-blue-700/20 -bottom-40 left-1/4" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo size="text-2xl" />
            <p className="mt-4 text-zinc-400 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
            <div className="mt-6 space-y-2 text-sm">
              <a href="mailto:contactbbrgo@gmail.com" className="flex items-center gap-2 text-zinc-300 hover:text-cyan-400 transition-colors duration-300">
                <Mail className="w-4 h-4" /> contactbbrgo@gmail.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">{t("footer.navTitle")}</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/a-propos" className="hover:text-white transition-colors duration-300">{t("nav.about")}</Link></li>
              <li><Link to="/nfc" className="hover:text-white transition-colors duration-300">{t("nav.nfc")}</Link></li>
              <li><Link to="/fiches-digitales" className="hover:text-white transition-colors duration-300">{t("nav.digital")}</Link></li>
              <li><Link to="/tarifs" className="hover:text-white transition-colors duration-300">{t("nav.pricing")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">{t("footer.companyTitle")}</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/contact" className="hover:text-white transition-colors duration-300">{t("nav.contact")}</Link></li>
              <li><Link to="/connexion" className="hover:text-white transition-colors duration-300">{t("nav.clientArea")}</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-white transition-colors duration-300">{t("footer.mentions")}</Link></li>
              <li><Link to="/confidentialite" className="hover:text-white transition-colors duration-300">{t("footer.privacy")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-500">
          <p>© {new Date().getFullYear()} BBR.GO — {t("footer.rights")}</p>
          <p className="font-mono text-xs">{t("footer.slogan")}</p>
        </div>
      </div>
    </footer>
  );
}
